export default "__VITE_ASSET__DJ$s8b66__"